module.exports = __webpack_public_path__ + "static/media/bitcoin.be35cc14.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/bitcoin.png
// module id = 1801
// module chunks = 146